// firebaseConfig.jsx
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
   apiKey: "AIzaSyAlu2aZrT-azD6qQsqjR8j5qfhGQUTOOQ4",
  authDomain: "saqcart.firebaseapp.com",
  databaseURL: "https://saqcart-default-rtdb.firebaseio.com",
  projectId: "saqcart",
  storageBucket: "saqcart.firebasestorage.app",
  messagingSenderId: "276555073626",
  appId: "1:276555073626:web:596aed33fe4392ca897063"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app); // Initialize Firebase storage

export { db, auth, storage };
